import React from "react";
import logger from "logger";
import TaskDialog from "TaskDialogCommon/TaskDialog";
import RunButton from "TaskDialogCommon/RunButton";
import TaskInput from "TaskDialogCommon/TaskInput";
import TaskCheckBox from "TaskDialogCommon/TaskCheckBox";
import TroopMapSelector from "TaskDialogCommon/TroopMapSelector";
import StringList from "TaskDialogCommon/StringList";
import HeroObjectSelector from "TaskDialogCommon/HeroObjectSelector";
import { getStyleJSON } from "Utils/Common";
import { getLastConfigForTask } from "Utils/Common";

const taskname = "shardstealer";

const headerToListName = {
  "Hit Alliance having Ids": "includeAllianceIds",
  "Hit Alliance having Names": "includeAllianceNames",
  "Hit Players having Ids": "includePlayerIds",
  "Hit Players having Names": "includePlayerNames",
  "Exclude Players having Ids": "excludePlayerIds",
  "Exclude Players having Names": "excludePlayerNames",
};

export default class Component extends React.Component {
  constructor(props) {
    super();
    const { accountdetailrow } = props;
    const initialState = {
      taskConfig: {
        accountdetail: accountdetailrow,
        selectedhero: {},
        noOfHits: "100",
        troops: {},
        unboxtroops: true,
        includeAllianceIds: [],
        includeAllianceNames: [],
        includePlayerIds: [],
        includePlayerNames: [],
        excludePlayerIds: [],
        excludePlayerNames: [],
        stealonlyshardsmorethan: 10,
      },
    };
    logger.log(`loading ${taskname} dialog`, props);
    this.loadStoredData(initialState, props);
    logger.log("initialState after load", initialState);
    this.state = initialState;
  }

  validate = () => {
    const {
      taskConfig: { selectedhero, noOfHits, troops },
    } = this.state;
    if (!selectedhero || Object.keys(selectedhero).length === 0) {
      alert("Please select a hero before continuing");
      return false;
    }
    if (!troops || Object.keys(troops).length === 0) {
      alert("Please select troops to use before continuing");
      return false;
    }
    if (noOfHits <= 0) {
      alert("Please increase number of hits to atleast one");
      return false;
    }
    return true;
  };

  loadStoredData = (initialState, props) => {
    const { taskConfig } = initialState;
    try {
      const { AccountDetailData: accountdetail } = props;
      var storeddata = getLastConfigForTask(taskname);
      logger.log("storeddata", storeddata, accountdetail);
      if (storeddata) {
        for (var key in accountdetail.heroes) {
          var cityObj = accountdetail.heroes[key];
          for (var hkey in cityObj.cityheroes) {
            var heroObj = cityObj.cityheroes[hkey];
            if (heroObj.heroname === storeddata.selectedhero.heroname) {
              taskConfig.selectedhero = heroObj;
            }
          }
        }
        taskConfig.noOfHits = storeddata.noOfHits;
        taskConfig.troops = { ...storeddata.troops };
        taskConfig.unboxtroops = storeddata.unboxtroops;
        taskConfig.includeAllianceIds = [...storeddata.includeAllianceIds];
        taskConfig.includeAllianceNames = [...storeddata.includeAllianceNames];
        taskConfig.includePlayerIds = [...storeddata.includePlayerIds];
        taskConfig.includePlayerNames = [...storeddata.includePlayerNames];
        taskConfig.excludePlayerIds = [...storeddata.excludePlayerIds];
        taskConfig.excludePlayerNames = [...storeddata.excludePlayerNames];
        taskConfig.stealonlyshardsmorethan = storeddata.stealonlyshardsmorethan;
      }
    } catch (e) {
      logger.log(e);
    }
  };

  setValue = (event, key) => {
    const value = event.target.value;
    this.setState((s, p) => ({
      taskConfig: { ...s.taskConfig, [key]: value },
    }));
  };

  render = () => {
    const {
      setValue,
      validate,
      state: { taskConfig },
      props: { AccountDetailData },
    } = this;

    return (
      <TaskDialog heading={"Mine Booter/Shard Stealer"}>
        <HeroObjectSelector
          label={"Select Hero"}
          AccountDetailData={AccountDetailData}
          taskConfig={taskConfig}
          setValue={setValue}
          param={"selectedhero"}
        />
        <TaskInput
          label={"No of hits"}
          value={taskConfig.noOfHits}
          onChange={(event) => setValue(event, "noOfHits")}
        />
        <TaskInput
          label={"Steal only when shards are more than.."}
          value={taskConfig.stealonlyshardsmorethan}
          onChange={(event) => setValue(event, "stealonlyshardsmorethan")}
        />

        <TaskCheckBox
          label={"Auto Unbox Troops when needed."}
          param={"unboxtroops"}
          taskConfig={taskConfig}
          setValue={setValue}
        />

        {Object.keys(headerToListName).map((header) => {
          const listname = headerToListName[header];
          return (
            <div style={{ border: "solid 1px;" }}>
              <StringList
                label={header}
                taskConfig={taskConfig}
                param={listname}
                setValue={setValue}
              />
            </div>
          );
        })}

        <TroopMapSelector
          AccountDetailData={AccountDetailData}
          taskConfig={taskConfig}
          setValue={setValue}
          label={"Add Troops To Send"}
          param={"troops"}
        />

        <RunButton
          taskname={taskname}
          taskConfig={taskConfig}
          label={"Run Mine Booter"}
          validate={validate}
        />
      </TaskDialog>
    );
  };
}
